import { useState } from "react";
import SwitchCard from "../../ui/SwitchCard/SwitchCard";
import ConfirmationModal from "../../ui/Modal/ConfirmationModal";
import styles from "./CancelModal.module.scss";
import { SlashCircle } from "../../ui/Icon/Icon";

function CancelModal({
  onClose,
  fetching,
  onSubmit,
  articleCounts,
  isOpen,
}: {
  isOpen: boolean;
  fetching: boolean;
  onClose: () => void;
  onSubmit: (state: {
    cancelProcessing: boolean;
    cancelQueued: boolean;
  }) => Promise<void>;
  articleCounts?: { queued: number; processing: number };
}) {
  const [cancelProcessing, setCancelProcessing] = useState(true);
  const [cancelQueued, setCancelQueued] = useState(true);

  const queued = Math.max(articleCounts?.queued || 0);
  const notQueued = Math.max((articleCounts?.processing || 0) - queued, 0);

  return (
    <ConfirmationModal
      loading={fetching || !isOpen}
      onClose={onClose}
      onSubmit={async () => onSubmit({ cancelProcessing, cancelQueued })}
      confirmDisabled={
        (!cancelProcessing && !cancelQueued) || queued + notQueued === 0
      }
    >
      {(notQueued > 0 || queued > 0) && (
        <div className={styles.cards}>
          {notQueued > 0 && (
            <SwitchCard
              IconComponent={SlashCircle}
              checked={cancelProcessing}
              onToggle={() => setCancelProcessing((previous) => !previous)}
              title={`Cancel ${notQueued} processing ${
                notQueued === 1 ? "article" : "articles"
              }`}
              subtitle="Credits will not be refunded"
            />
          )}
          {queued > 0 && (
            <SwitchCard
              IconComponent={SlashCircle}
              checked={cancelQueued}
              onToggle={() => setCancelQueued((previous) => !previous)}
              title={`Cancel ${queued} queued ${
                queued === 1 ? "article" : "articles"
              }`}
              subtitle="Credits will be refunded"
            />
          )}
        </div>
      )}
    </ConfirmationModal>
  );
}

export default CancelModal;
